import { render, staticRenderFns } from "./PRadioGroup.vue?vue&type=template&id=66f6b2e8"
import script from "./PRadioGroup.vue?vue&type=script&lang=js"
export * from "./PRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports